import React from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

export default function Thankyou({ hideSocial, disableAutoRedirect }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (disableAutoRedirect) return;

    const timer = setTimeout(() => {
      navigate("/");
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate, disableAutoRedirect]);

  return (
    <div className="thankyou-page">
      <div className="thankpage-box">
        <div className="thankbox">
          <img src="/image/thankyou.webp" className="img-responsive" alt="Thankyou" />
          <h1 className="heading">Your Journey With Sonam Begins Here</h1>
          <p>
            Your request has been received. We look forward to styling you in contemporary designs where intricate
            craftsmanship meets effortless comfort and enduring beauty.
          </p>

          {!hideSocial && (
            <ul className="footer-social">
              <li>
                <Link
                  to={"https://www.facebook.com/profile.php?id=61561567174333"}
                  target="_blank"
                  aria-label="Facebook"
                >
                  <Icons name="facebook" />
                </Link>
              </li>
              <li>
                <Link to={"https://www.instagram.com/sonamslabel"} target="_blank" aria-label="instagram">
                  <Icons name="instagram" />
                </Link>
              </li>
              <li>
                <Link to={"https://www.pinterest.com/sonamlabel"} target="_blank" aria-label="pinterest">
                  <Icons name="pinterest" />
                </Link>
              </li>
              <li>
                <Link to={"https://www.youtube.com/@SonamLabel"} target="_blank" aria-label="youtube">
                  <Icons name="youtube" />
                </Link>
              </li>
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
